import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TabErrorBannerProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

const TabErrorBanner = ({
  title = "Error al cargar datos",
  message = "Ocurrió un problema al cargar la información. Intenta nuevamente.",
  onRetry,
}: TabErrorBannerProps) => {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-red-300 bg-red-50 p-4">
      <AlertCircle className="h-5 w-5 text-red-600 mt-0.5" />

      <div className="flex-1">
        <h3 className="text-sm font-semibold text-red-800">{title}</h3>
        <p className="mt-1 text-sm text-red-700">{message}</p>

        {onRetry && (
          <div className="mt-3">
            <Button
              variant="outline"
              size="sm"
              onClick={onRetry}
              className="text-red-700 border-red-300 hover:bg-red-100"
            >
              Reintentar
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabErrorBanner;
